import React, { useState, useEffect } from "react";
import Client from "../../common/axiosApi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ourclient.css";

const Ourclient = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [logos, setLogos] = useState([]);

  const getLogos = async () => {
    try {
      const response = await Client.get("client/getclient");
      if (response.status === 200) {
        setLogos(response.data.logo);
      }
    } catch (error) {
      console.error("Error fetching logos:", error);
    }
  };

  useEffect(() => {
    getLogos();
  }, []);

  return (
    <div className="container-fluid clientwrapper">
        <h2 className="mt-3">Our Esteemed Clients</h2>
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index}>
            <img
              src={logo.icon.url}
              alt="clientlogo"
              className="clientlogo"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Ourclient;
